import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import TableCicloOrcamentarioPluriAnualProps from '../RelatorioCicloOrcamentarioPluriAnual/TableCicloOrcamentarioPluriAnual';
import {
  CrfCicloOrcamentarioRelatorio,
  postGetAllRelatorioCicloOrcamentarioPluriAnual,
  CrfFiltros,
} from '@app/api/crf/crfRelatorioCicloorcamentario';

const { Panel } = Collapse;
import AbaPacote from '../RelatorioCicloOrcamentarioProjetoPluriAnual/AbaPacote';
import GraficoPluriAnual from '../RelatorioCicloOrcamentarioProjetoPluriAnual/GraficoPluriAnual';
import { hasPermission } from '@app/helpers/permissions';
import { exportaRelatorioPluriAnualExcel } from '@app/api/crf/crfRelatorioProjetoPacote';

interface ResultCicloAnoProps {
  projetoId: string;
  projetoCodigo: string;
  nomeProjeto: string;
}

const ResultPluriAnual = ({ projetoId, projetoCodigo, nomeProjeto }: ResultCicloAnoProps) => {
  const idTodos = '00000000-0000-0000-0000-000000000000';
  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();
  const filtros = {} as CrfFiltros;

  useEffect(() => {
    if (projetoId) {
      if (projetoId === idTodos) {
        postGetAllRelatorioCicloOrcamentarioPluriAnual(filtros).then(data => {
          setCicloOrcamentarioRelatorioTotal(data);
        });
      }
    }
  }, [projetoId]);

  const hasExpostarRelatorio = () => {
    exportaRelatorioPluriAnualExcel(filtros);
  };

  const btnExportar = () => {
    if (hasPermission(['PROJETOS_TODOS_PROJETOS_PLURI_ANUAL_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
      return [
        <Button
          type="primary"
          name="btnExportar"
          icon="files-ms_excel"
          onClick={() => {
            hasExpostarRelatorio();
          }}>
          <FormatText id="data-export" uppercase transform={() => 'Exportar Relatório'} />
        </Button>,
      ];
    }
    return [];
  };

  return projetoId === idTodos && cicloOrcamentarioRelatorioTotal ? (
    <>
      <GridView noform>
        <Widget title="RESULTADO" span={12} actions={btnExportar()}>
          <TableCicloOrcamentarioPluriAnualProps
            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
            ocultarColunaDetalhe={true}
            paginacaoConfig={{
              pageSize: 10,
              onChange: () => {
                document.getElementById('tableCicloOrcamentarioPluriAnual').scrollIntoView();
              },
            }}
          />
        </Widget>
      </GridView>
    </>
  ) : projetoId != idTodos ? (
    <>
      <AbaPacote
        projetoId={projetoId}
        pageSize={10}
        projetoCodigo={projetoCodigo}
        mostrarBotalExportarADistribuir={true}
        nomeProjeto={nomeProjeto}
      />
      <GraficoPluriAnual projetoId={projetoId} exportarCurvaEconomicaPluriAnual={true} />
    </>
  ) : (
    <></>
  );
};

export default ResultPluriAnual;
